import React, { useState, useEffect } from 'react';
import { Typography, Box, Tab, Tabs } from '@mui/material';
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import supabase from '../../supabaseClient';
import NewHoursReport from '../../Components/Manager/Attendance/NewHoursReport/NewHoursReport';
import WorkerReportList from '../../Components/Manager/Attendance/WorkerReportList';
import WorkerReportDetail from '../../Components/Manager/Attendance/WorkerReportDetail';

function ManagerSettlements() {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [idConfig, setIdConfiguration] = useState('');

  useEffect(() => {
    const init = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData.session) return;
      const userId = sessionData.session.user.id;
      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('id_configuration')
        .eq('id', userId)
        .single();
      if (profileError || !profileData) {
        console.log('Błąd pobierania profilu:', profileError);
        return;
      }
      setIdConfiguration(profileData.id_configuration);
    };
    init();
  }, []);

  return (
    <ManagerNavBar>
      <Box sx={{ px: 6, py: 2 }}>
        <Typography sx={{ fontSize: '30px', fontWeight: 700, color: 'primary.main', mb: 3 }}>
          Rozliczenia
        </Typography>

        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ mb: 2 }}
        >
          <Tab label="Rozliczenia" />
          <Tab label="Pracownicy" />
        </Tabs>

        {activeTab === 0 && (
          <Box>
            <NewHoursReport idConfig={idConfig} />
          </Box>
        )}

        {activeTab === 1 && (
          <Box>
            {selectedWorker ? (
              <WorkerReportDetail
                employee={selectedWorker}
                idConfig={idConfig}
                onBack={() => setSelectedWorker(null)}
              />
            ) : (
              <WorkerReportList idConfig={idConfig} onSelect={setSelectedWorker} />
            )}
          </Box>
        )}
      </Box>
    </ManagerNavBar>
  );
}

export default ManagerSettlements;
